 import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Master
import MasterReducer from './master/reducer';

// Authentication
import AuthReducer from './auth/reducer'

//Brands
import BrandListReducer from "./brand/list/reducer";
import BrandDataReducer from './brand/reducer';

//Users
import UserListReducer from "./users/list/reducer"
import UserDataReducer from "./users/reducer"
import UserBrandsReducer from "./users/brands/reducer";
import RolesReducer from "./users/roles/reducer"

//Campaigns
import CampaignsReducer from "./campaigns/reducer";
import CampaignDetailsReducer from "./campaigns/details/reducer";
import CampaignRequirementsReducer from "./campaigns/requirements/reducer";
import CampaignCreativesReducer from "./campaigns/creatives/reducer";
import CampaignMilestonesReducer from "./campaigns/milestones/reducer";
import CampaignApplicationsReducer from "./campaigns/applications/reducer";
import CampaignCollaborationsReducer from "./campaigns/collaborations/reducer";
import CampaignPaymentsReducer from "./campaigns/payments/reducer";
import CampaignInsightsReducer from "./campaigns/insights/reducer";
import CampaignPerformanceReducer from "./campaigns/performance/reducer"

import InfluencersReducer from "./influencer/reducer";
import CollaborationMilestoneReducer from "./campaigns/collaborations/milestones/reducer";
import UIReducer from "./ui/reducer";
import AddressBookReducer from "./addressBook/reducer";
import PermalinkFilesReducer from "./files/reducer";
import CampaignPermalinksReducer from "./campaigns/permalinks/reducer";
import ContentLibraryReducer from "./campaigns/content/reducer";
import ChatListReducer from "./chat/list/reducer"
import WalletReducer from "./wallet/reducer";
import SocialAccountReducer from "./socialAccounts/reducer"
import CampaignPostsReducer from "./campaigns/posts/reducer"
import CampaignRecommendedCreatorsReducer from "./campaigns/recommended-creators/reducer"
import CampaignInvitesReducer from "./campaigns/invites/reducer"
import CompetitionAnalysisReducer from "./competitionAnalysis/reducer";
import DashboardReducer from "./dashboard/reducer";
import CollectionReducer from "./collections/reducer"
import MembershipReducer from "./membership/reducer"
import CreatorsReducer from "./creators/reducer"
import CreatorDiscoveryReducer from "./creatorDiscovery/reducer"

const rootReducer = combineReducers({
    Layout: LayoutReducer,
    master: MasterReducer,
    auth: AuthReducer,
    brandList: BrandListReducer,
    brandData: BrandDataReducer,
    userList: UserListReducer,
    userData: UserDataReducer,
    userBrands: UserBrandsReducer,
    roles: RolesReducer,
    campaigns: CampaignsReducer,
    campaignRequirements: CampaignRequirementsReducer,
    campaignMilestones: CampaignMilestonesReducer,
    campaignCreatives: CampaignCreativesReducer,
    campaignDetails: CampaignDetailsReducer,
    campaignApplications: CampaignApplicationsReducer,
    influencers: InfluencersReducer,
    collaborations: CampaignCollaborationsReducer,
    campaignPayments: CampaignPaymentsReducer,
    campaignInsights: CampaignInsightsReducer,
    campaignPerformance: CampaignPerformanceReducer,
    ui: UIReducer,
    collaborationMilestones: CollaborationMilestoneReducer,
    addressBook: AddressBookReducer,
    permalinkFiles: PermalinkFilesReducer,
    campaignPermalinks: CampaignPermalinksReducer,
    contentLibrary: ContentLibraryReducer,
    chatList: ChatListReducer,
    walletState: WalletReducer,
    socialAccountState: SocialAccountReducer,
    campaignPosts: CampaignPostsReducer,
    campaignRecommendedCreators: CampaignRecommendedCreatorsReducer,
    campaignInvites: CampaignInvitesReducer,
    competitionAnalysis: CompetitionAnalysisReducer,
    dashboard: DashboardReducer,
    collections: CollectionReducer,
    membershipState: MembershipReducer,
    creators: CreatorsReducer,
    creatorDiscovery: CreatorDiscoveryReducer
});

export default rootReducer;